export const keys = {
    clientID: '910587914066-a79tgllt99stia0bqfihhhbf4vb3u812.apps.googleusercontent.com',
    URL: 'https://cruzhacks2021-301707.wl.r.appspot.com/'
}